import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  count: number;
  singular: string;
  plural: string;
  isExpanded: boolean;
  onToggle: () => void;
};

export const CommentsToggle = ({
  count,
  singular,
  plural,
  isExpanded,
  onToggle,
}: Props) => (
  <div className="flex items-center gap-4">
    <button
      type="button"
      onClick={onToggle}
      className="text-xs font-normal text-[#5F1ECC]"
    >
      {count === 1 ? `1 ${singular}` : `${count} ${plural}`}
    </button>
    {count > 0 && (
      <button
        type="button"
        onClick={onToggle}
        className="flex items-center gap-2 text-xs font-normal text-[#5F1ECC]"
      >
        <span>{isExpanded ? 'Hide' : 'Show'}</span>
        <FontAwesomeIcon
          icon={isExpanded ? faChevronUp : faChevronDown}
          className="size-2"
        />
      </button>
    )}
  </div>
);
